import { ServiceDefinition } from '@pershing/pershing-core';

export class MutualFundTradingServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'trading/mutualfund';
    version: string = 'v1';
    family: string = 'pershing';
    appName: string = 'mutualfund-trading';
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!MutualFundTradingServiceDefinition.instance) {
            MutualFundTradingServiceDefinition.instance = new MutualFundTradingServiceDefinition();
            if (platform === 'retail') {
                MutualFundTradingServiceDefinition.instance.family = 'netxinvestor';
                MutualFundTradingServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return MutualFundTradingServiceDefinition.instance;
    }

    
    private constructor() {
        //intentional empty constructor
    }
}
